import SkillSchema from 'schemas/skill.schema'
import { z } from 'zod'

export const BaseEmploymentHistorySchema = z.object({
  id: z.string().nullable().optional(),
  employerName: z.string(),
  jobTitle: z.string(),
  description: z.string().nullable(),
  skills: SkillSchema.array(),
  startDate: z
    .string()
    .transform((value) =>
      value ? new Date(value).toLocaleDateString('lt') : ''
    ),
  endDate: z
    .string()
    .nullable()
    .optional()
    .transform((value) =>
      value ? new Date(value).toLocaleDateString('lt') : null
    )
})

const EmploymentHistorySchema = BaseEmploymentHistorySchema.extend({
  skills: SkillSchema.array().min(1)
})

export default EmploymentHistorySchema
